import { ReactElement } from 'react';
import { formatTranslation, unsafeTranslationKey } from 'intl';
import { useIntl } from 'react-intl';
import { customizedFields } from 'components/dataProviders/withCustomizedFields';
import { LabelledCardList } from 'components/common/labelledCard/list';
import { LabelledCard } from 'components/common/labelledCard/single';

export function FieldsSettings(): ReactElement {
  const intl = useIntl();
  const cardItems = Object.values(customizedFields).map((field) => {
    return {
      key: field.fieldName,
      label: formatTranslation(intl, unsafeTranslationKey(field.fieldLabelId),),
      redirectTo: `/fieldsSettings/${field.fieldName}`,
    };
  });

  return (
    <LabelledCardList>
      {cardItems.map((cardItem) => (
        <LabelledCard
          key={cardItem.key}
          label={cardItem.label}
          redirectTo={cardItem.redirectTo}
        />
      ))}
    </LabelledCardList>
  );
}

